import { render, staticRenderFns } from "./DrawTools.vue?vue&type=template&id=04a5c87e&scoped=true&"
import script from "./DrawTools.vue?vue&type=script&lang=js&"
export * from "./DrawTools.vue?vue&type=script&lang=js&"
import style0 from "./DrawTools.vue?vue&type=style&index=0&id=04a5c87e&prod&scoped=true&lang=css&"
import style1 from "./DrawTools.vue?vue&type=style&index=1&id=04a5c87e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a5c87e",
  null
  
)

export default component.exports